// import React, { useState } from "react";
// import { toast } from "react-toastify";
// import Search from "../../components/form/Search";
// import Table from "../../components/elements/table/Table";
// import { setTitle } from "../../helpers/MetaTag";
// import { handleFilterChange } from "../../helpers";

// import useFetch from "../../hooks/useFetch";
// import { useDebounce } from "../../hooks/useDebounce";
// import LimitSelect from "../../components/elements/LimitSelect";
// import useMutation from "../../hooks/useMutation";
// import Switch from "../../components/form/Switch";
// import Badge from "../../components/elements/Badge";
// import {
//   emailTemplateList,
//   emailTemplateOrdering,
//   emailTemplateStatusChange,
// } from "../../services/emailService";
// import ManageEmailTemplateModal from "../../components/sections/admin/emailTemplate/modals/ManageEmailTemplateModal";

// const EmailTemplate = () => {
//   setTitle("MemoryDoodle Admin | Email Templates");
//   const [selectedItems, setSelectedItems] = useState([]);
//   const [modalOpen, setModalOpen] = useState({ isOpen: false, data: null });
//   const [keyword, setKeyword] = useState("");
//   const search = useDebounce(keyword, 300);
//   const [filters, setFilters] = useState({
//     limit: 10,
//     page: 1,
//     sortQuery: "ordering",
//   });

//   const emailName = {
//     "send-otp": "Send Otp",
//     "welcome-email-user": "Welcome Email",
//     "reset-pass-link-invite": "Reset Password",
//     donation: "Donation",
//     "send-contact-us-rec": "Contact Us",
//     "email-change": "Change Email",
//   };

//   const { data, error, isLoading, updateData, isFetching, refetch } = useFetch({
//     dependencies: ["emailtemplate", filters, search],
//     fetchFunction: async () => {
//       const {
//         status = [],

//         ...restFilters
//       } = filters || {};
//       const res = await emailTemplateList({
//         ...restFilters,
//         ...Object.fromEntries(status.map((val, i) => [`status[${i}]`, val])),
//         ...(search && { keyword: search }),
//       });
//       return res?.docs;
//     },
//   });

//   //   Application Form status change handler =================>
//   const { mutate: statusChangeHandler, isPending: statusChangeInPending } =
//     useMutation({
//       mutationFn: async ({ id, status }) => {
//         const res = await emailTemplateStatusChange({
//           ids: [id],
//           status,
//         });
//         return { res, payload: { id, status } };
//       },
//       onSuccess: ({ res, payload }) => {
//         if (res?.status !== 200) {
//           updateData((pre) => {
//             pre.data = (pre?.data || []).map((elm) =>
//               elm?._id === payload?.id
//                 ? { ...elm, status: payload?.status === 1 ? 2 : 1 }
//                 : elm
//             );
//             return { ...pre };
//           });
//         }
//       },
//       onError: (error) => {
//         console.log(error);
//       },
//     });

//   const tableHeadData = [
//     {
//       _id: 1,
//       name: "Email For",
//       align: "left",
//     },
//     {
//       _id: 2,
//       name: "Subject",
//       align: "left",
//     },
//     {
//       _id: 3,
//       name: "From Name",
//       align: "left",
//     },
//     {
//       _id: 4,
//       name: "Status",
//       align: "left",
//       isFilter: true,
//       isFilterSearch: false,
//       onFilter: (val) => {
//         if (val?.length > 0) {
//           setFilters((pre) => ({
//             ...pre,
//             status: val?.map((item) => item?.value),
//             page: 1,
//           }));
//         } else {
//           setFilters((pre) => {
//             delete pre?.status;
//             return { ...pre };
//           });
//         }
//       },
//       filterData: [
//         { name: "Active", value: 1, type: "checkbox" },
//         { name: "Inactive", value: 2, type: "checkbox" },
//       ],
//     },
//     {
//       _id: 5,
//       name: "Action",
//       align: "center",
//     },
//   ];

//   // Table Body Data =====================>
//   const tableData = data?.data?.map((item) => {
//     return {
//       _id: item?._id,
//       rowData: [
//         {
//           _id: 1,
//           type: "text",
//           align: "left",
//           cellClass: "!min-w-[100px]",
//           data:
//             (
//               <div
//                 dangerouslySetInnerHTML={{
//                   //   __html: emailName[item?.code] || "-",
//                   __html: item?.code || "-",
//                 }}
//               ></div>
//             ) || "-",
//         },
//         {
//           _id: 2,
//           type: "text",
//           align: "left",
//           cellClass: "!min-w-[100px]",
//           data:
//             (
//               <div
//                 dangerouslySetInnerHTML={{
//                   __html: item?.subject || "-",
//                 }}
//               ></div>
//             ) || "-",
//         },
//         {
//           _id: 3,
//           type: "text",
//           align: "left",
//           cellClass: "!min-w-[100px]",
//           data:
//             (
//               <div
//                 dangerouslySetInnerHTML={{ __html: item?.fromName || "-" }}
//               ></div>
//             ) || "-",
//         },
//         {
//           _id: 4,
//           type: "text",
//           align: "left",
//           cellClass: "!min-w-[100px]",
//           data: (
//             <div className="flex gap-2 items-center">
//               <Switch
//                 className={
//                   "!w-10 !h-5 before:!w-4 before:!h-4 peer-checked:before:!left-[22px]"
//                 }
//                 checked={item?.status === 1}
//                 onChange={() => {
//                   updateData((pre) => {
//                     pre.data = (pre?.data || []).map((elm) =>
//                       elm?._id === item?._id
//                         ? { ...elm, status: elm?.status === 1 ? 2 : 1 }
//                         : elm
//                     );
//                     return { ...pre };
//                   });
//                   statusChangeHandler({
//                     id: item?._id,
//                     status: item?.status === 1 ? 2 : 1,
//                   });
//                 }}
//               />
//               <Badge
//                 type={item?.status === 1 ? "success" : "danger"}
//                 label={item?.status === 1 ? "Active" : "Inactive"}
//               />
//             </div>
//           ),
//         },
//         {
//           _id: 5,
//           type: "action",
//           align: "left",
//           cellClass: "w-[4%]",
//           actionData: [
//             {
//               _id: 1,
//               name: "Edit",
//               icon: "fa-regular fa-pen-to-square",
//               onClick: () => {
//                 setModalOpen({ isOpen: true, data: item });
//               },
//               standout: false,
//             },
//           ],
//         },
//       ],
//     };
//   });

//   // add or edit Application Form =================>
//   function applicationFormManageResponse(res) {
//     if (res?.status === 200 || res?.status === 201) {
//       if (res?.status === 201) {
//         if (filters?.page === 1) {
//           updateData((pre) => ({ ...pre, data: [res?.data, ...pre?.data] }));
//           refetch();
//         } else {
//           setFilters((pre) => ({ ...pre, page: 1 }));
//         }
//       }
//       if (res?.status === 200) {
//         updateData((pre) => ({
//           ...pre,
//           data: pre?.data?.map((item) =>
//             item?._id === res?.data?._id ? res?.data : item
//           ),
//         }));
//       }
//       setModalOpen({ isOpen: false, data: null });
//     } else {
//       toast.warning(res?.message);
//     }
//   }

//   async function emailTemplateOrderingHandler(newData, oldData) {
//     console.log({ newData, oldData });

//     const ordering_data = newData?.map((item, i) => ({
//       id: item?._id,
//       ordering: i,
//     }));
//     const res = await emailTemplateOrdering({ ordering_data });
//     if (res?.status !== 200) {
//       updateData((pre) => {
//         pre.data = oldData;
//         return { ...pre };
//       });
//     }
//   }

//   return (
//     <div className="space-y-4 w-full flex flex-col pb-10">
//       <div className="space-y-8">
//         <div className="font-bold text-center text-lg xl:text-3xl text-chestnut-rose">
//           Email Templates
//         </div>

//         <div className="flex items-center gap-3">
//           <div className="w-36">
//             <LimitSelect
//               value={filters?.limit}
//               allValue={data?.metadata?.totalDocs}
//               onChange={(val) => handleFilterChange("limit", val, setFilters)}
//             />
//           </div>
//           <div className="w-72">
//             <Search
//               placeholder={"Search here"}
//               search={(val) => {
//                 setKeyword(val);
//                 handleFilterChange("page", 0, setFilters);
//               }}
//             />
//           </div>
//           {/* <div className="relative">
//             <Button
//               buttonClasses={
//                 "!bg-transparent border border-transparent !h-10 hover:!bg-chestnut-rose/10 hover:!border-chestnut-rose/10"
//               }
//               buttonLabel={"Create New"}
//               buttonLabelClasses={"font-medium !text-sm text-chestnut-rose"}
//               buttonFunction={() => setModalOpen({ isOpen: true, data: null })}
//             />
//           </div> */}
//         </div>
//       </div>
//       <Table
//         tableHeadData={tableHeadData}
//         tableData={tableData}
//         isLoder={isLoading}
//         pageCount={data?.metadata?.totalPages}
//         currentPage={filters?.page}
//         onPageChange={(val) => {
//           handleFilterChange("page", val, setFilters);
//           setSelectedItems([]);
//         }}
//         handleOrdering={(newData, oldData) => {
//           emailTemplateOrderingHandler(newData, oldData);
//         }}
//         originalData={[...(data?.data || [])]}
//         setOriginalData={(data) =>
//           updateData((pre) => {
//             pre.data = data;
//             return { ...pre };
//           })
//         }
//         isFetching={isFetching}
//         isOrderingDisabled={false}
//         selectedItems={selectedItems}
//         setSelectedItems={setSelectedItems}
//         tableActionDropdownContainer={"!w-48"}
//       />
//       <ManageEmailTemplateModal
//         open={modalOpen?.isOpen}
//         data={modalOpen?.data}
//         close={() => setModalOpen({ isOpen: false, data: null })}
//         getResponse={applicationFormManageResponse}
//       />
//     </div>
//   );
// };

// export default EmailTemplate;

import React, { useState } from "react";
import { toast } from "react-toastify";
import Search from "../../components/form/Search";
import Table from "../../components/elements/table/Table";
import { setTitle } from "../../helpers/MetaTag";
import { handleFilterChange } from "../../helpers";
import useMutation from "../../hooks/useMutation";
import useFetch from "../../hooks/useFetch";
import { useDebounce } from "../../hooks/useDebounce";
import LimitSelect from "../../components/elements/LimitSelect";
import Switch from "../../components/form/Switch";
import Badge from "../../components/elements/Badge";
import {
  emailTemplateList,
  emailTemplateOrdering,
  emailTemplateStatusChange,
} from "../../services/emailService";
import ManageEmailTemplateModal from "../../components/sections/admin/emailTemplate/modals/ManageEmailTemplateModal";

const EmailTemplate = () => {
  setTitle("MemoryDoodle Admin | Email template");
  const [selectedItems, setSelectedItems] = useState([]);

  const [modalOpen, setModalOpen] = useState({ isOpen: false, data: null });
  const [keyword, setKeyword] = useState("");
  const search = useDebounce(keyword, 300);
  const [filters, setFilters] = useState({
    limit: 10,
    page: 1,
    sortQuery: "-createdAt",
  });

  const emailName = {
    "send-otp": "Send Otp",
    "welcome-email-user": "Welcome Email",
    "reset-pass-link-invite": "Reset Password",
    donation: "Donation",
    "send-contact-us-rec": "Contact Us",
    "email-change": "Change Email",
    scholarship_submission: "Scholarship Submission",
    application_status_track: "Application Status Track",
    application_status_reminder: "Application Status Reminder",
    "donor-send-invite": "Donor Send Invite",
    "contact-us-admin-notify": "Contact Us Admin Notify",
    "user-account-delete": "User Account Delete",
    scholarship_submission_admin_notify: "Scholarship Submission Admin Notify",
    "send-message": "Send Message",
    donation_received: "Donation Received",
  };

  const { data, error, isLoading, updateData, isFetching, refetch } = useFetch({
    dependencies: ["emailtemplate", filters, search],
    fetchFunction: async () => {
      const {
        status = [],

        ...restFilters
      } = filters || {};
      const res = await emailTemplateList({
        ...restFilters,
        ...Object.fromEntries(status.map((val, i) => [`status[${i}]`, val])),
        ...(search && { keyword: search }),
      });
      return res?.docs;
    },
  });

  const { mutate: statusChangeHandler, isPending: statusChangeInPending } =
    useMutation({
      mutationFn: async ({ id, status }) => {
        // Optimistically update the local data
        updateData((prev) => {
          const updated = (prev?.data || []).map((item) =>
            item?._id === id ? { ...item, status } : item
          );
          return { ...prev, data: updated };
        });

        const res = await emailTemplateStatusChange({
          ids: [id],
          status,
        });

        return { res, payload: { id, status } };
      },

      onSuccess: ({ res, payload }) => {
        if (res?.status !== 200) {
          // Revert the change if API failed
          updateData((prev) => {
            const reverted = (prev?.data || []).map((item) =>
              item?._id === payload.id
                ? {
                    ...item,
                    status: item.status === "active" ? "deactivated" : "active",
                  }
                : item
            );
            return { ...prev, data: reverted };
          });

          toast.warning(res?.message || "Status update failed.");
        }
      },

      onError: (err) => {
        console.error("Mutation error:", err);
      },
    });

  const tableHeadData = [
    {
      _id: 1,
      name: "Email For",
      align: "left",
    },
    // {
    //   _id: 2,
    //   name: "Subject",
    //   align: "left",
    // },
    {
      _id: 3,
      name: "From Name",
      align: "left",
    },
    {
      _id: 4,
      name: "Status",
      align: "left",
    },
    // {
    //   _id: 5,
    //   name: "Action",
    //   align: "left",
    // },
  ];

  // Table Body Data =====================>
  const tableData = data?.data?.map((item) => {
    return {
      _id: item?._id,
      rowData: [
        {
          _id: 1,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          // cellClass: "truncate whitespace-nowrap",
          data:
            (
              <div
                dangerouslySetInnerHTML={{
                  __html: emailName[item?.code] || item?.code || "-",
                }}
              ></div>
            ) || "-",
        },
        // {
        //   _id: 2,
        //   type: "text",
        //   align: "left",
        //   cellClass: "!min-w-[100px]",
        //   data:
        //     (
        //       <div
        //         dangerouslySetInnerHTML={{
        //           __html: item?.subject || "-",
        //         }}
        //       ></div>
        //     ) || "-",
        // },
        {
          _id: 3,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          // cellClass: "truncate whitespace-nowrap",
          data: item?.from?.name || "-",
        },
        {
          _id: 4,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          // cellClass: "truncate whitespace-nowrap",
          data: (
            <div className="flex gap-2 items-center">
              <Switch
                className={
                  "!w-10 !h-5 before:!w-4 before:!h-4 peer-checked:before:!left-[22px]"
                }
                checked={item?.status === "active"}
                onChange={() => {
                  statusChangeHandler({
                    id: item?._id,
                    status:
                      item?.status === "active" ? "deactivated" : "active",
                  });
                }}
              />
              <Badge
                type={item?.status === "active" ? "success" : "danger"}
                label={item?.status}
              />
            </div>
          ),
        },
        // {
        //   _id: 5,
        //   type: "action",
        //   align: "left",
        //   // cellClass: "w-[5%]",
        //   // cellClass: "truncate whitespace-nowrap",
        //   actionData: [
        //     {
        //       _id: 1,
        //       name: "Edit",
        //       icon: "fa-regular fa-pen-to-square",
        //       onClick: () => {
        //         setModalOpen({ isOpen: true, data: item });
        //       },
        //       standout: false,
        //     },
        //   ],
        // },
      ],
    };
  });

  // add or edit Application Form =================>
  function emailFormManageResponse(res) {
    if (res?.status === 200 || res?.status === 201) {
      if (res?.status === 201) {
        if (filters?.page === 1) {
          updateData((prev) => ({
            ...prev,
            data: [res?.data, ...(prev?.data || [])],
          }));

          // Optionally validate totalDocs if needed before refetch
          if (data?.metadata?.totalDocs > filters?.limit) {
            refetch();
          }
        } else {
          setFilters((prev) => ({ ...prev, page: 1 }));
        }
      }

      if (res?.status === 200) {
        updateData((prev) => ({
          ...prev,
          data: (prev?.data || []).map((item) =>
            item?._id === res?.data?._id ? { ...item, ...res?.data } : item
          ),
        }));
      }

      setModalOpen({ isOpen: false, data: null });
    } else {
      toast.warning(res?.message || res?.error || "Something went wrong.");
    }
  }

  //   // add or edit Application Form =================>
  // function emailFormManageResponse(res) {
  //   if (res?.status === 200 || res?.status === 201) {
  //     if (res?.status === 201) {
  //       if (filters?.page === 1) {
  //         updateData((pre) => ({ ...pre, data: [res?.data, ...pre?.data] }));
  //         refetch();
  //       } else {
  //         setFilters((pre) => ({ ...pre, page: 1 }));
  //       }
  //     }
  //     if (res?.status === 200) {
  //       updateData((pre) => ({
  //         ...pre,
  //         data: pre?.data?.map((item) =>
  //           item?._id === res?.data?._id ? res?.data : item
  //         ),
  //       }));
  //     }
  //     setModalOpen({ isOpen: false, data: null });
  //   } else {
  //     toast.warning(res?.message);
  //   }
  // }

  async function emailTemplateOrderingHandler(newData, oldData) {
    console.log({ newData, oldData });

    const ordering_data = newData?.map((item, i) => ({
      id: item?._id,
      ordering: i,
    }));
    const res = await emailTemplateOrdering({ ordering_data });
    if (res?.status !== 200) {
      updateData((pre) => {
        pre.data = oldData;
        return { ...pre };
      });
    }
  }
  return (
    <div className="space-y-4 w-full flex flex-col pb-10">
      <div className="space-y-8">
        <div className="font-bold text-center text-lg xl:text-3xl text-primary  text-chestnut-rose">
          Email Templates
        </div>

        <div className="flex items-center gap-3">
          <div className="w-36">
            <LimitSelect
              value={filters?.limit}
              allValue={data?.metadata?.totalDocs}
              onChange={(val) => handleFilterChange("limit", val, setFilters)}
            />
          </div>
          <div className="w-72">
            <Search
              placeholder={"Search here"}
              search={(val) => {
                setKeyword(val);
                handleFilterChange("page", 1, setFilters);
              }}
            />
          </div>
          {/* <div className="relative">
            <Button
              buttonClasses={
                "!bg-transparent border border-transparent !h-10 hover:!bg-primary/10 hover:!border-primary/10"
              }
              buttonLabel={"Create New"}
              buttonLabelClasses={"font-medium !text-sm text-primary"}
              buttonFunction={() => setModalOpen({ isOpen: true, data: null })}
            />
          </div> */}
        </div>
      </div>
      <Table
        tableHeadData={tableHeadData}
        tableData={tableData}
        isLoder={isLoading}
        pageCount={data?.metadata?.totalPages}
        currentPage={filters?.page}
        onPageChange={(val) => {
          handleFilterChange("page", val, setFilters);
          setSelectedItems([]);
        }}
        handleOrdering={(val) => {
          console.log(val);
        }}
        isFetching={isFetching}
        isOrderingDisabled={true}
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
        tableActionDropdownContainer={"!w-48"}
      />
      <ManageEmailTemplateModal
        open={modalOpen?.isOpen}
        data={modalOpen?.data}
        close={() => setModalOpen({ isOpen: false, data: null })}
        getResponse={emailFormManageResponse}
      />
    </div>
  );
};

export default EmailTemplate;
